"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRect = void 0;
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
function useRect(...keys) {
    const keysRef = (0, react_1.useRef)(keys);
    const [rect, setRect] = (0, react_1.useState)();
    const ref = (0, react_1.useRef)(null);
    const node = ref.current;
    const measure = (0, react_1.useCallback)(() => {
        if (node) {
            window.requestAnimationFrame(() => {
                const nodeBounds = getRect(node);
                const { width, height } = nodeBounds;
                if (width && height) {
                    const newRect = (0, utils_1.pick)(nodeBounds, ...keysRef.current);
                    setRect(JSON.stringify(newRect));
                }
            });
        }
    }, [node]);
    (0, react_1.useEffect)(() => {
        if (node) {
            measure();
            window.addEventListener('resize', measure);
            window.addEventListener('scroll', measure);
            return () => {
                window.removeEventListener('resize', measure);
                window.removeEventListener('scroll', measure);
            };
        }
    }, [node, measure]);
    return (0, react_1.useMemo)(() => [ref, rect && JSON.parse(rect)], [rect]);
}
exports.useRect = useRect;
function getRect(node) {
    const rect = node.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: 'x' in rect ? rect.x : rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: 'y' in rect ? rect.y : rect.left,
    };
}
